/* =========================================================================
   Enrollment kill-switch.

   The course isn't finished, so nobody should be able to pay the founding fee
   yet. When enrollment is CLOSED the offer page (/subscriptions) and the
   sign-up-and-pay page (/register-to-plan) show a "coming soon" notice instead
   of sending anyone to Stripe, and the checkout service calls are no-ops.

   Enrollment is closed unless REACT_APP_ENROLLMENT_OPEN is explicitly "true".
   `.env.development` turns it on so local work can still exercise the whole
   Stripe flow; `.env.production` carries an explicit empty override. Never put
   the flag in plain `.env` — CRA loads that for production builds too, so it
   would silently ship enrollment open.

   CRA inlines REACT_APP_* at build time, so opening enrollment means editing
   `.env.production` and running `npm run build` + redeploy. Setting it on the
   server does nothing (same deal as REACT_APP_TTS_PROVIDER).
   ========================================================================= */

export const ENROLLMENT_OPEN =
  String(process.env.REACT_APP_ENROLLMENT_OPEN || "").trim().toLowerCase() === "true";

export default ENROLLMENT_OPEN;
